<kpi4me-text-element
  style="padding-top: 0.5rem;"
  [formControlElement]="tableGuidForm"
  [data]="tableGuidFormData"
  [matAutocomplete]="auto"
/>
<mat-autocomplete
  #auto="matAutocomplete"
  class="guid-autocomplete"
>
  @for (suggestion of guidSuggestions; track suggestion.value) {
    <mat-option [value]="suggestion.value">
      <span class="guid-suggestion-key">{{ suggestion.key }}</span>
      <span class="guid-suggestion-separator">&nbsp;&ndash;&nbsp;</span>
      <span class="guid-suggestion-value">{{ suggestion.value }}</span>
    </mat-option>
  }
</mat-autocomplete>

@if (render()) {
  <lib-guid-table-control
    [inputGUID]="tableGuid()"
  />
}
